var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirectionLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 68,
    viewBox: "0 0 63 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8045 53.3256L27.4216 49.3894L15.6725 36.5756L57.1534 36.5756V30.9923L15.6725 30.9923L27.4472 18.1785L23.8045 14.2423L5.8474 33.784L23.8045 53.3256Z",
    fill: "#B2CE53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectionLeft);
export default __webpack_public_path__ + "static/media/Direction Left.4d8efcbbfeb3c0802e3f586af4b8b639.svg";
export { ForwardRef as ReactComponent };